// project import
import dashboard from './dashboard';
import virtualGuard from './virtualGuard';
import rentalManager from './rentalManager';
import cloudVideo from './cloudVideo';
import settings from './settings';
import superAdmin from './superAdmin';
import lpr from './lpr';
import devicesManager from './devices';
import shortTermRental from './shortTermRental';
import guardReports from './guardReports';
import trafficCitations from './trafficCitations';

// resi imports
import { resiDashboard, userArea } from './resi';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [
        dashboard,
        virtualGuard,
        devicesManager,
        cloudVideo,
        rentalManager,
        shortTermRental,
        guardReports,
        trafficCitations,
        lpr,
        superAdmin,
        settings
    ],
    resiItems: [resiDashboard, userArea]
};

export default menuItems;
